"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseRolloutsVariablesFromCookieValue = void 0;
var _regeneratorRuntime = _interopRequireDefault(require("regenerator-runtime"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /**
 *
 * Define and configure variants for flagged features and A/B tests.
 * ===================================================================================
 * Examples:
 *
 * Define feature/experiment (what we put into our code, so we have a reference)
 *   prosper.featureFlags.setFeature('miicardFlow', [ '5-step', '4-step' ])
 *
 * Check if experiment is running (what you paste into optimizely configuration code)
 *   prosper.featureFlags.isRunning('miicardFlow')
 *
 * Set current variant (what you paste into optimizely variant code)
 *   prosper.featureFlags.activateVariant('miicardFlow', '4-step');
 *
 */
// This function fetches the value from the urlMap Object based on the host name
var fetchOptimizelyValue = function fetchOptimizelyValue() {
  var href = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.href;
  var urlMap = arguments.length > 1 ? arguments[1] : undefined;
  // 01-29-2021 : Updating logic to facilitate host+path keys match
  // Eg: www.xyz.com/heloc matches to 123 & www.xyz.com/home-equity matches to 456
  var optimizelyKey = Object.keys(urlMap).reduce(function (latestMatch, currentKey) {
    return href.includes(currentKey) ? currentKey : latestMatch;
  }, null);

  // if the string match exists as a key in the `urlMap` object return the value OR undefined
  var url = urlMap[optimizelyKey];

  // if (!url) throw new Error('Optimizely library failed to load');
  if (!url) console.log('Optimizely library failed to load');
  return url;
};
var featuresFromUrl = {};
var userId = "";
var optimizelyClientInstance = null;
var userContext = null;
function getUrlParamValue(param) {
  var queryStringMatch = window.location.href.match(/\?(.*)/); // returns an array or null. index 0 is the match, index 1 is the first capture group

  var query = queryStringMatch && queryStringMatch[1] ? queryStringMatch[1] : '';
  var params = query.split('&');
  for (var i = 0; i < params.length; i++) {
    var pair = params[i].split('=');
    if (pair[0] === param) {
      return pair[1];
    }
  }
  return '';
}
// used to force experiments manually
function loadFlagsFromURL() {
  var urlFlags = getUrlParamValue('flags');
  if (typeof urlFlags === 'string') {
    var hashes = urlFlags.split(',');
    for (var i = 0; i < hashes.length; i++) {
      var keypair = hashes[i].split(':');
      if (keypair.length > 1) {
        featuresFromUrl[keypair[0]] = keypair[1];
      }
    }
  }
}
function userContextDecision(name) {
  if (userContext && typeof userContext.decide === 'function') {
    return userContext.decide(name);
  }
  return null;
}
function isRunning(name) {
  if (featuresFromUrl[name]) {
    return true;
  }
  var ffValueInCookie = checkFeatureFlagInCookie(name); // To use cookie override - when a feature flag has a value in cookie, its running
  if (ffValueInCookie !== null) {
    return ffValueInCookie;
  }
  var decision = userContextDecision(name);
  return decision && decision.enabled;
}
function getActiveVariant(name) {
  var targetedUserId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (typeof name !== 'string') return null;
  if (featuresFromUrl[name]) {
    return featuresFromUrl[name];
  }
  var ffValueInCookie = checkFeatureFlagInCookie(name);
  if (ffValueInCookie !== null) {
    return ffValueInCookie;
  }
  var trackHeap = function trackHeap(key, value, fxCustomKey) {
    if (window.heap) {
      var obj = {};
      obj[key] = value;
      window.heap.addUserProperties(obj);
      if (fxCustomKey) {
        window.heap.track(fxCustomKey, {
          activeVariant: value
        });
      }
    }
  };

  // check if it is an targetted feature by userId
  if (targetedUserId !== null) {
    userId = targetedUserId;
  }

  // check if it is an optimizely rollouts feature
  var decision = userContextDecision(name);
  if (decision && decision.enabled) {
    // add heap tracking for the experiment
    trackHeap("track-rollouts-".concat(name), decision.variationKey, "customEvent_fx_".concat(name));
    return decision.variationKey;
  }
  return null;
}
var isJsonString = function isJsonString() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  if (typeof input !== "string") {
    return false;
  }
  try {
    JSON.parse(input);
    return true;
  } catch (error) {
    return false;
  }
};
var FEATURE_FLAG_SEPERATOR = '||';
var FEATURE_NAME_AND_VARIABLES_SEPERATOR = '@';
var FEATURE_VARIABLES_SEPERATOR = '|';
var VARIABLE_KEY_AND_VALUE_SEPERATOR = '=';

/**
 *
 * @param {string} valueString: "value of cookie _variables"
 * @returns Js Object
 *
 * Example param: heloc_state_footprint@AL=true|TX=true|AZ=false||heloc_location_footprint@city={"Miami":true}
 *
 * - feature flags are seperated by ||
 * - feature name and variables are seperated by '@'
 * - feature variables are seperated by '|'
 * - variable key and value are seperated by '='
 */
var parseRolloutsVariablesFromCookieValue = exports.parseRolloutsVariablesFromCookieValue = function parseRolloutsVariablesFromCookieValue() {
  var valueString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var featureFlagsAndVariables = {};
  if (valueString && valueString !== "") {
    // Split string at ';' to seperate multiple feature flags
    var featureFlags = valueString.split(FEATURE_FLAG_SEPERATOR);
    // For each FF, split at '=' to divide feature flag name and variables
    featureFlags && featureFlags.map(function (featureFlag) {
      var featureFlagSplit = featureFlag.split(FEATURE_NAME_AND_VARIABLES_SEPERATOR);
      if (featureFlagSplit && featureFlagSplit.length > 1) {
        var featureName = featureFlagSplit[0];
        featureFlagsAndVariables[featureName] = {};
        // For variables, split at '|' to divide into multiple variables
        var variables = featureFlagSplit[1].split(FEATURE_VARIABLES_SEPERATOR);
        // For each varible, split at ':' to divide into variable key and value
        if (featureName && featureName !== "" && variables && variables !== "") {
          variables && variables.map(function (variable) {
            var variableSplit = variable.split(VARIABLE_KEY_AND_VALUE_SEPERATOR);
            var variableKey = variableSplit[0];
            var variableValue = variableSplit[1];
            if (variableKey && variableKey !== "" && variableValue && variableValue !== "") {
              featureFlagsAndVariables[featureName][variableKey] = isJsonString(variableValue) ? JSON.parse(variableValue) : variableValue;
            }
          });
        }
      }
    });
  }
  return featureFlagsAndVariables;
};

// Returns a JSON object containing feature variable keys and values.
// Returns null if feature key is invalid, returns an empty object if there are no feature variables
function getRolloutFeatureVariables(featureKey) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var cookieValueToOverride = getCookieValue('_variables');
  if (cookieValueToOverride) {
    var featureFlagsAndVariables = parseRolloutsVariablesFromCookieValue(cookieValueToOverride);
    if (featureFlagsAndVariables && featureFlagsAndVariables[featureKey]) {
      // Found cookie override, return its variables.
      return featureFlagsAndVariables[featureKey];
    }
  }
  var decision = userContextDecision(featureKey);
  if (decision) return decision['variables'];
  return null;
}

// Returns {string|number|boolean|JSON|null} The value of the variable,
// or null if the feature key is invalid, the variable key is invalid, or there is a mismatch with the type of the variable.
function getRolloutFeatureVariable(featureKey, variableKey) {
  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var cookieValueToOverride = getCookieValue('_variables');
  if (cookieValueToOverride) {
    var featureFlagsAndVariables = parseRolloutsVariablesFromCookieValue(cookieValueToOverride);
    if (featureFlagsAndVariables && featureFlagsAndVariables[featureKey] && featureFlagsAndVariables[featureKey][variableKey]) {
      // Found cookie override, return variable value.
      return featureFlagsAndVariables[featureKey][variableKey];
    }
  }
  var decision = userContextDecision(featureKey);
  if (decision) return decision['variables'][variableKey];
  return null;
}
function isActiveVariant(name, variantName) {
  if (typeof name !== 'string' || typeof variantName !== 'string') return false;
  if (featuresFromUrl[name]) {
    return variantName === featuresFromUrl[name];
  }

  // To use cookie override - when a feature flag has a value in cookie, check against it and return response
  var ffValueInCookie = checkFeatureFlagInCookie(name);
  if (ffValueInCookie !== null) {
    return variantName === ffValueInCookie;
  }
  var decision = userContextDecision(name);
  if (decision && decision.enabled) {
    return decision.variationKey === variantName;
  }
  return false;
}
function getCookieValue(cname) {
  if (typeof document !== "undefined") {
    var cookieValue = document.cookie.match('(^|[^;]+)\\s*' + cname + '\\s*=\\s*([^;]+)');
    return cookieValue ? cookieValue.pop() : '';
  }
  return '';
}
function addCookieToBrowser(cName, cValue) {
  if (typeof document !== "undefined") {
    document.cookie = "".concat(cName, "=").concat(cValue, ";secure");
  }
}

/**
 * Parse cookie, of the form:
 * _features=flag:activeVariant,flag:activeVariant
 */
function checkFeatureFlagInCookie(featureFlagName) {
  var cookieFlags = getCookieValue('_features');
  if (typeof cookieFlags === 'string') {
    var featureFlagsinCookie = cookieFlags.split(',');
    for (var i = 0; i < featureFlagsinCookie.length; i++) {
      var keypair = featureFlagsinCookie[i].split(':');
      if (featureFlagName === keypair[0]) {
        return keypair[1];
      }
    }
    return null;
  }
}

// Feature experimentation Id's
var optimizelyRollOutMap = {
  'localhost:': 'HnyauTjF63qm8q5nEDzT6',
  'local.prosper:': 'HnyauTjF63qm8q5nEDzT6',
  'localhost:3000': 'HnyauTjF63qm8q5nEDzT6',
  'prosper.local': 'HnyauTjF63qm8q5nEDzT6',
  'www.prosper.local': 'HnyauTjF63qm8q5nEDzT6',
  'www.qa32.circleone.com': 'GPL1AzcEgCKPaGQ5jFbE67',
  'www.stage.circleone.com': 'UhaV9SGAWGkynMaRAWcaF3',
  'www.uat.circleone.com': 'RZYjpxa2Q4VP9R4eYvn1i3',
  'www.prosper.com': 'VA4F3tJ2MezHW1X3eXibD6'
};

// userId is optional, it is only for loggedIn User. If the user is not logged in, generate a random number as userId and store it in cookie.
function loadFeatureFlags() {
  return _loadFeatureFlags.apply(this, arguments);
}
function _loadFeatureFlags() {
  _loadFeatureFlags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime["default"].mark(function _callee() {
    var loggedInUserId,
      _args = arguments;
    return _regeneratorRuntime["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            loggedInUserId = _args.length > 0 && _args[0] !== undefined ? _args[0] : null;
            // userId is a global variable since getActiveVariant need to use it.
            userId = loggedInUserId || getUserIdFromCookieOrGenerateUserId();
            loadFlagsFromURL();
            _context.next = 5;
            return loadOptimizelyRollouts(optimizelyRollOutMap);
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadFeatureFlags.apply(this, arguments);
}
function getDevelopmentURL() {
  var localDevelopment = ['localhost:', 'prosper.local', 'www.prosper.local'];
  return localDevelopment.some(function (devHost) {
    return window && window.location && window.location.host.includes(devHost);
  }) ? 'https://www.qa32.circleone.com' : null;
}
function loadOptimizelyRollouts(_x) {
  return _loadOptimizelyRollouts.apply(this, arguments);
} // checks for cookie value
// If cookie is not present, generates a random cookie and stores it in cookie
function _loadOptimizelyRollouts() {
  _loadOptimizelyRollouts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime["default"].mark(function _callee2(optimizelyRollOutMap) {
    var optimizely, urlOrigin, urlTemplate, hostname, locationHref, sdkKey, result;
    return _regeneratorRuntime["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            optimizely = require('@optimizely/optimizely-sdk');
            urlOrigin = getDevelopmentURL();
            urlTemplate = "/optimizelyproxy/v1/datafiles";
            if (urlOrigin) {
              urlTemplate = "".concat(urlOrigin).concat(urlTemplate);
            }
            if (optimizelyRollOutMap) {
              hostname = window.location.hostname.includes('workers.dev') ? 'www.qa32.circleone.com' : window.location.hostname;
              locationHref = "".concat(window.location.protocol, "//").concat(hostname).concat(window.location.pathname);
              sdkKey = fetchOptimizelyValue(locationHref, optimizelyRollOutMap);
              urlTemplate = "".concat(urlTemplate, "/").concat(sdkKey, ".json");
            }
            // Instantiate an Optimizely client
            optimizelyClientInstance = optimizely.createInstance({
              sdkKey: '1234',
              datafileOptions: {
                autoUpdate: true,
                urlTemplate: urlTemplate
              }
            });
            _context2.next = 8;
            return optimizelyClientInstance.onReady({
              timeout: 2000
            });
          case 8:
            result = _context2.sent;
            if (!result.success) {
              console.log(result.reason);
            } else {
              userContext = optimizelyClientInstance.createUserContext(userId, {});
            }
          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _loadOptimizelyRollouts.apply(this, arguments);
}
function getUserIdFromCookieOrGenerateUserId() {
  var COOKIE_NAME = '_userIdForFeatureFlag';
  var userId = getCookieValue(COOKIE_NAME);
  if (!userId) {
    // If no cookie found, generate a random guid and store it in cookie
    userId = generateRandomGUID();
    addCookieToBrowser(COOKIE_NAME, userId);
  }
  return userId;
}
function generateRandomGUID(a) {
  return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, generateRandomGUID);
}

///This is purely for borrower-dashboard angularJS
(function () {
  if (typeof window === "undefined") return;
  window.prosper = window.prosper || {};
  window.prosper.featureFlags = {
    isRunning: isRunning,
    getActiveVariant: getActiveVariant,
    isActiveVariant: isActiveVariant,
    loadFeatureFlags: loadFeatureFlags,
    getRolloutFeatureVariables: getRolloutFeatureVariables,
    getRolloutFeatureVariable: getRolloutFeatureVariable
  };
})();
//----------

module.exports = {
  isRunning: isRunning,
  getActiveVariant: getActiveVariant,
  isActiveVariant: isActiveVariant,
  loadFeatureFlags: loadFeatureFlags,
  getRolloutFeatureVariables: getRolloutFeatureVariables,
  getRolloutFeatureVariable: getRolloutFeatureVariable
};